var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "growth (1) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33268 3.99935C5.33268 3.26298 4.73572 2.66602 3.99935 2.66602C3.26298 2.66602 2.66602 3.26298 2.66602 3.99935V25.3327C2.66602 27.5419 4.45688 29.3327 6.66602 29.3327H27.9993C28.7358 29.3327 29.3327 28.7358 29.3327 27.9993C29.3327 27.2629 28.7358 26.666 27.9993 26.666H6.66602C5.92964 26.666 5.33268 26.0691 5.33268 25.3327V3.99935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.3378 17.1564C21.8887 17.4712 22.585 17.3542 23.0028 16.8767L27.6695 11.5434C28.1543 10.9892 28.0982 10.1469 27.5441 9.66199C26.9899 9.17707 26.1475 9.23323 25.6626 9.78742L21.714 14.3001L13.3276 9.50776C12.7767 9.193 12.0804 9.30996 11.6626 9.78742L6.99593 15.1207C6.51102 15.6749 6.56718 16.5173 7.12136 17.0022C7.67554 17.4871 8.51789 17.4309 9.0028 16.8767L12.9514 12.3641L21.3378 17.1564Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/Growth.a5abc20cae60f2330f020079c51900ff.svg";
export { ForwardRef as ReactComponent };